import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";

import { LucideAngularModule, X } from "lucide-angular";

import { CustomIconComponent } from "@shared/components/custom-icon/custom-icon.component";
import { CustomIconName } from "@shared/icons/icon-definitions";

@Component({
  selector: "component-chip",
  imports: [LucideAngularModule, CustomIconComponent],
  templateUrl: "./chip.component.html",
  styleUrl: "./chip.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    "[title]": "text()"
  }
})
export class ChipComponent {
  readonly text = input.required<string>();
  readonly icon = input<CustomIconName>();
  readonly iconViewBox = input<string>("0 0 24 24");
  readonly iconSize = input<number | string>(24);
  readonly iconColor = input<string>("currentColor");

  readonly remove = output<void>();

  protected readonly closeIcon = X;

  protected onRemove(event: Event): void {
    event.stopPropagation();
    this.remove.emit();
  }
}
